import React from "react"
import CrudGrid from "../../views/app/modules/crudGrid"
import { findModuleInMenu, getUsersModulePath } from "../../helpers/Utils"

export default (context) => {
  const listenCreateSuccess = (success) => {
    if (success) context.getData()
  }

  const crudAdmOrderGrid = () => {
    return (
      <CrudGrid
        ctx={ctx => context.ctxAdmOrderGrid = ctx}
        match={{ path: '/app/admOrderGrid' }}
        onlyCrud={true}
        listenCreateSuccess={listenCreateSuccess}
      />
    ) 
  }

  const usersPath = getUsersModulePath()
  
  const admOrderDetail = () => {
    return context.state.idItemSelected ?
    {
      module: 'admOrderDetail',
      parentIdField: 'ID'
    } : null
  }

  return {
    config: {
      pageSize: 40,
      list: false
    },

    actions: {
      create: {
        btn: () => {
          context.ctxAdmOrderGrid.state.formFlags.bulk = false
          context.ctxAdmOrderGrid.view.actions.create.reloadGrid = false
          context.ctxAdmOrderGrid.toggle()
        }
      },
      edit: true,
      delete: true,
      print: true,
      export: true,
      search: true
    },

    extras: {
      forms: [
        {
          type: "customComponent",
          component: crudAdmOrderGrid
        }
      ],
      items: [
        {
          id: 1, icon: 'simple-icon-reload', name: 'En masivo', onClick: (ctx) => {
            context.ctxAdmOrderGrid.state.formFlags.bulk = true
            context.ctxAdmOrderGrid.view.actions.create.reloadGrid = false
            context.ctxAdmOrderGrid.toggle();
          }
        },
      ]
    },

    filter: {
      fields: [
        {
          name: "studentId",
          value: "",
          type: "select",
          label: "Alumno",
          opts: {
            style: 'float-label',
            searchOnline: true,
            path: `/${usersPath}/get?enrolled=-1&pick=true`,
            withImg: true
          }
        },
        {
          type: "daterange"
        },
        {
          name: "status",
          value: 0,
          type: "select",
          label: "Estado",
          opts: {
            style: 'float-label',
            items: [
              {
                value: -1,
                label: "Anulado"
              },
              {
                value: 0,
                label: "No pagado"
              },
              {
                value: 1,
                label: "Pagado"
              }
            ]
          }
        }
      ],
      buttons: [
        {
          label: 'Aplicar filtro',
          renderIf: (ctx) => { return ctx.state.from || ctx.state.to || Number.isInteger(ctx.state.status) || Number.isInteger(ctx.state.studentId) },
          onClick: (ctx) => { ctx.btnAction('filter') }
        }
      ]
    },

    form: {
      detailGrid: findModuleInMenu(context.props.menuItems, "id", "admOrderDetail") ? admOrderDetail : null,
      handleSaveChanges : () => {
        context.edit()
      },
      fields: [
        {
          col: 6,
          name: "easyId",
          value: "",
          type: "text",
          label: "Número de documento",
          rules: 'required',
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 6,
          name: "externalId",
          value: null,
          type: "text",
          label: "Código externo",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "curr",
          value: null,
          type: "text",
          label: "Moneda",
          disabled: true,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "total",
          value: null,
          type: "text",
          label: "Monto",
          disabled: true,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "brief",
          value: "",
          type: "text",
          label: "Concepto",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "dueDate",
          value: null,
          type: "date",
          label: "Vencimiento",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "created",
          value: null,
          type: "date",
          label: "Fecha creación",
          disabled: true,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "hasPenalty",
          value: false,
          type: "switch",
          label: "Penalidad",
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "principalName",
          value: null,
          type: "text",
          label: "Nombre responsable",
          rules: 'required',
          disabled: true,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "dependantName",
          value: null,
          type: "text",
          label: "Nombre dependiente",
          rules: 'required',
          disabled: true,
          opts: {
            style: 'float-label'
          }
        },
        { name: "paid", type: "hidden" },
        {
          col: 2,
          name: "btnPayOrder",
          value: null,
          type: "button",
          label: "Registrar pago",
          opts: {
            style: 'float-label'
          },
          renderIf: (ctx) => !ctx.state.paid,
          onClick: (ctx) => {
            ctx.toogleSubForm(0)
          }
        },
        {
          col: 2,
          name: "btnPayments",
          value: null,
          type: "button",
          label: "Ver pagos",
          // renderIf: (ctx) => ctx.state.paid,
          onClick: (ctx) => {
            ctx.toogleSubGrid(0)
          }
        },
        {
          col: 12,
          name: "ID",
          value: null,
          type: "text",
          label: "ID de orden",
          disabled: true,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 12,
          name: "voidOrder",
          value: null,
          type: "button",
          label: "Anular pago",
          opts: {
            kind: 'danger'
          },
          renderIf: (ctx) => ctx.state.paid,
          onClick: (ctx) => {
            ctx.toogleSubForm(1)
          }
        },
      ],
      subGrids: [
        {
          module: 'admBilling',
          filterBy: () => { return { orderId: context.state.idItemSelecte, range: { value: 1  } } }
        }
      ],
      subforms: [
        {
          name: 'Registrar pago',
          postUrlF: (ctx) => 'admBilling/setpaymentbyorder/' + ctx.state.ID,
          autoClose: true,
          fields: [
            {
              col: 12,
              name: "amount",
              value: '',
              type: "number",
              label: "Monto",
              hint: "Ingrese el monto total",
              rules: 'required',
              opts: {
                style: 'float-label',
                tooltip: true
              }
            },
            {
              col: 12,
              name: "note",
              value: '',
              type: "text",
              label: "Referencia",
              hint: "Ingrese una nota sobre este pago",
              rules: 'required',
              opts: {
                style: 'float-label',
                tooltip: true
              }
            },
            {
              name: "card",
              value: "",
              col: 12,
              type: "select",
              label: "Medio",
              hint: "Medio de pago",
              opts: {
                style: 'float-label',
                items: [
                  {
                    value: "CASH",
                    label: "Efectivo"
                  },
                  {
                    value: "DEPOSIT",
                    label: "Depósito en cuenta"
                  },
                  {
                    value: "OTHER",
                    label: "Otro"
                  }
                ],
                isMulti: false,
                tooltip: true
              }
            }
          ],
          buttons: [
            {
              label: 'Registrar pago',
              col: 12,
              isMain: true,
              onClick: (ctx) => { ctx.btnAction('save') }
            }
          ],
          onSuccess: (r) => { context.getDataById(context.state.idItemSelected) },
          onError: (e) => { },
        },
        {
          name: 'Anular pago',
          getUrlF: (ctx) => 'admOrder/request2pay/' + ctx.state.ID,
          postUrlF: (ctx) => 'admBilling/refundbyorder/' + ctx.state.ID,
          autoClose: true,
          fields: [
            {
              col: 12,
              name: "amount",
              value: '',
              type: "number",
              label: "Monto",
              disabled: true,
              opts: {
                style: 'float-label',
                tooltip: true
              }
            },
            {
              col: 12,
              name: "note",
              value: '',
              type: "text",
              label: "Referencia",
              hint: "Ingrese una nota sobre esta anulación",
              rules: 'required',
              opts: {
                style: 'float-label',
                tooltip: true
              }
            },
            {
              name: "card",
              value: "",
              col: 12,
              type: "select",
              label: "Medio",
              hint: "Medio de reembolso",
              opts: {
                style: 'float-label',
                items: [
                  {
                    value: "CASH",
                    label: "Efectivo"
                  },
                  {
                    value: "DEPOSIT",
                    label: "Depósito en cuenta"
                  },
                  {
                    value: "OTHER",
                    label: "Otro"
                  }
                ],
                isMulti: false,
                tooltip: true
              }
            }
          ],
          buttons: [
            {
              label: 'Registrar anulación',
              col: 12,
              isMain: true,
              onClick: (ctx) => { ctx.btnAction('save') }
            }
          ],
          onSuccess: (r) => { context.getDataById(context.state.idItemSelected) },
          onError: (e) => { },
        }
      ]
    },

    columns: [
      {
        Header: "Nombre responsable",
        accessor: "principalName",
        minWidth: 200
      },
      {
        Header: "Dependiente",
        accessor: "dependantName"
      },
      {
        Header: "Fecha",
        accessor: "date",
        isDate: true
      },
      {
        Header: "Vencimiento",
        accessor: "dueDate",
        isDate: true
      },
      {
        Header: "Monto",
        accessor: "total",
        isDecimal: true,
        minWidth: 50
      },
      {
        Header: "Concepto",
        accessor: "det"
      },
      {
        Header: "Código externo",
        accessor: "externalId"
      },
      {
        Header: "Pagado",
        accessor: "paid",
        isBool: true,
        minWidth: 50
      }
    ]
  }
}